import { render } from "./ThePatientConsultationScrollItem.vue?vue&type=template&id=56530bbe&scoped=true&ts=true"
import script from "./ThePatientConsultationScrollItem.vue?vue&type=script&lang=ts"
export * from "./ThePatientConsultationScrollItem.vue?vue&type=script&lang=ts"

import "./ThePatientConsultationScrollItem.vue?vue&type=style&index=0&id=56530bbe&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56530bbe"]])

export default __exports__